__turbopack_context__.v({
  "cardContainer": "uywIeq_cardContainer",
  "cardWrapper": "uywIeq_cardWrapper",
  "grid": "uywIeq_grid",
  "header": "uywIeq_header",
  "mobileViewAll": "uywIeq_mobileViewAll",
  "section": "uywIeq_section",
  "title": "uywIeq_title",
  "viewAllIcon": "uywIeq_viewAllIcon",
  "viewAllLink": "uywIeq_viewAllLink",
});
